<template>

      <div class="wrap inputAreaWrap">
          <div class="wrappedContent inputArea">

              <div class="narrowHeader row">
                  <div class="col-7">
                      <h2>世帯主について</h2>
                  </div>

                  <div class="col-5 text-right">
                      <img src="@/assets/img/input/indicator_1.png" class="indicatorImg" alt="">
                  </div>
              </div>


              <div class="row" :class="{'alert-danger': isInputAlert&&!setainushi.age}">
                  <div class="col-4 col-lg-5 text-right">
                      <label>年齢</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <select v-model="setainushi.age">
                          <option :value="value" v-for="(value,index) in selectOptionsData(18, 70)" :key="index">{{value}}</option>
                      </select>
                      <span class="unit-label">歳</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>職業</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <div class="btnBox">
                          <div class="btn" :class="{ active: setainushi.shokugyou == 1 }" @click="setainushi.shokugyou = 1">会社員</div>
                          <div class="btn" :class="{ active: setainushi.shokugyou == 2 }" @click="setainushi.shokugyou = 2">公務員</div>
                      </div>
                      <div class="btnBox">
                          <div class="btn" :class="{ active: setainushi.shokugyou == 3 }" @click="setainushi.shokugyou = 3">自営業</div>
                          <div class="btn" :class="{ active: setainushi.shokugyou == 4 }" @click="setainushi.shokugyou = 4">専業主婦/主夫</div>
                      </div>
                  </div>
              </div>

              <div class="row" :class="{'alert-danger': isInputAlert&&!setainushi.geshuu}">
                  <div class="col-4 col-lg-5 text-right">
                      <label>手取り月収</label>
                  </div>
                  <div class="col-8 col-lg-7 d-flex align-items-center">
                      <select v-model="setainushi.geshuu">
                          <option :value="value" v-for="(value,index) in selectOptionsData(1, 100)" :key="index">{{value}}</option>
                      </select>
                      <span class="unit-label">万円</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>手取りボーナス（年合計）</label>
                  </div>
                  <div class="col-8 col-lg-7 d-flex align-items-center">
                      <input type="text" inputmode="numeric" pattern="\d*" v-model="setainushi.bonus" @change="setainushi.bonus = zenHan($event)">
                      <span class="unit-label">万円</span>
                      <div class="input-description">手取り年収<br>{{ nenshu }}万円</div>
                  </div>
              </div>


              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>退職の年齢</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <select v-model="setainushi.retirementAge">
                          <option :value="data.value" v-for="(data,index) in selectOriginalOptionsData(setainushi.age*1, 90, 1, [{value:0, text:'退職予定なし'}])" :key="index">{{data.text}}</option>
                      </select>
                      <span v-if="setainushi.retirementAge !== 0" class="unit-label">歳</span>
                  </div>
              </div>


              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>現在の貯蓄額</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <input type="text" inputmode="numeric" pattern="\d*" v-model="setainushi.chochiku" @change="setainushi.chochiku = zenHan($event)">
                      <span class="unit-label">万円</span>
                  </div>
              </div>

              <div class="row alert alert-warning" v-if="showAlert">
                  <div class="col text-center">
                      ライフシミュレーションを算出するにあたり、<br>
                      <span v-if="!setainushi.age" class="font-weight-bold">「年齢」</span><span v-if="!setainushi.geshuu" class="font-weight-bold">「手取り月収」</span><br>
                      をご入力ください。
                  </div>
              </div>


              <div class="row btn-next-row" :class="{'next-row-with-alert': showAlert}">
                  <div class="col text-center">
                      <router-link to="/input2" class="btn btn-outline-primary btn-next">次に進む</router-link>
                  </div>
              </div>


      </div>

      </div>



</template>

<script>
import Calc from "@/store/calcUtil.js"
export default {
    name: "input1.vue",
    data() {
        return {
            setainushi:{
                age:null,
                shokugyou:null,
                geshuu:null,
                bonus: null,
                retirementAge:null,
                chochiku:null,
            },
            isInputAlert: false,
        }
    },
    computed: {
        nenshu() {
            let nenshu = this.setainushi.geshuu * 12 + this.setainushi.bonus*1;
            if (isNaN(nenshu)) {
                return 0;
            }
            return nenshu;
        },
        bothNoInput() {
            return !(this.setainushi.age && this.setainushi.geshuu);
        },
        showAlert() {
            return this.isInputAlert && this.bothNoInput;
        }
    },
    methods: {
        setInputsData() {
            this.$store.commit('setSetainushi', this.setainushi);
        },
        selectOptionsData(start, end, interval=1) {
            let options = [''];
            // console.log(interval);

            for (let i = start; i <= end; i = i+interval) {
                options.push(i);
            }

            return options;
        },
        selectOriginalOptionsData(start, end, interval=1, originals=[]) {
            let options = [{value:'', text:''}];

            if (originals.length){
                originals.forEach(obj => {
                    options.push(obj);
                });
            }

            for (let i = start; i <= end; i = i+interval) {
                options.push({value:i, text:i});
            }

            return options;
        },
        zenHan(e) {
            return Calc.han2Zen(e.target.value)
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.setainushi = Object.assign({}, vm.setainushi, vm.$store.state.setainushi);
        });
    },
    beforeRouteLeave(to, from, next) {
        //入力値のチェック
        //年齢
        if (this.nenshu == 0) {
            this.isInputAlert = true; //alertを表示する用
        }
        //収入
        if (this.nenshu == 0) {
            this.isInputAlert = true; //alertを表示する用
        }
        if (this.bothNoInput) { //isInputAlertをクリアするタイミングを作っていないので、inputチェックはbotuInputで行う
            return false;
        }

        this.setInputsData();
        this.isInputAlert = false; //リセット

        next();
    }
}
</script>

<style lang="scss" scoped>

.alert-danger {
    select {
        border-color: #dc3545;
        padding-right: calc(1.5em + 0.75rem) !important;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: center right 15px;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
}
.alert-warning {
    color: #6c0d0d;
    background-color: #fcf6e4;
    line-height: 16px;
    font-size: 14px;
    padding: 8px;
    margin-bottom: 15px !important;
}
.next-row-with-alert {
    margin-top: 0;
}
</style>


















